function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.65355 3.12952C1.02514 3.94711 0.551297 4.88945 0.275391 5.91317H4.4372L1.65355 3.12952Z",
  fill: "#0052B4"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M15.7242 5.91314C15.4483 4.88945 14.9745 3.94711 14.3461 3.12952L11.5625 5.91314H15.7242Z",
  fill: "#0052B4"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M0.275391 10.087C0.551328 11.1107 1.02517 12.0531 1.65355 12.8706L4.43711 10.087H0.275391Z",
  fill: "#0052B4"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M12.8701 1.65382C12.0525 1.02542 11.1101 0.551572 10.0864 0.275635V4.43742L12.8701 1.65382Z",
  fill: "#0052B4"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M3.12939 14.3462C3.94699 14.9746 4.88933 15.4484 5.91302 15.7244V11.5626L3.12939 14.3462Z",
  fill: "#0052B4"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M5.91299 0.275635C4.8893 0.551572 3.94696 1.02542 3.12939 1.65379L5.91299 4.43738V0.275635Z",
  fill: "#0052B4"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M10.0869 15.7244C11.1106 15.4484 12.0529 14.9746 12.8705 14.3462L10.0869 11.5626V15.7244Z",
  fill: "#0052B4"
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M11.5625 10.087L14.3461 12.8707C14.9745 12.0531 15.4483 11.1107 15.7242 10.087H11.5625Z",
  fill: "#0052B4"
});
var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M15.9323 6.95653H9.04353H9.0435V0.0677188C8.70191 0.02325 8.35366 0 8 0C7.64628 0 7.29809 0.02325 6.95653 0.0677188V6.95647V6.9565H0.0677188C0.02325 7.29809 0 7.64634 0 8C0 8.35372 0.02325 8.70191 0.0677188 9.04347H6.95647H6.9565V15.9323C7.29809 15.9768 7.64628 16 8 16C8.35366 16 8.70191 15.9768 9.04347 15.9323V9.04353V9.0435H15.9323C15.9768 8.70191 16 8.35372 16 8C16 7.64634 15.9768 7.29809 15.9323 6.95653Z",
  fill: "#D80027"
});
var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M10.0869 10.0871L13.6568 13.6569C13.821 13.4928 13.9776 13.3212 14.127 13.1433L11.0707 10.087H10.0869V10.0871Z",
  fill: "#D80027"
});
var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M5.91317 10.087H5.9131L2.34326 13.6569C2.50739 13.8211 2.67898 13.9777 2.85686 14.1271L5.91317 11.0708V10.087Z",
  fill: "#D80027"
});
var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M5.91317 5.91311V5.91305L2.3433 2.34314C2.17911 2.50726 2.02248 2.67886 1.87305 2.85673L4.92939 5.91308H5.91317V5.91311Z",
  fill: "#D80027"
});
var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M10.0869 5.91308L13.6568 2.34314C13.4927 2.17896 13.3211 2.02233 13.1432 1.87292L10.0869 4.92927V5.91308Z",
  fill: "#D80027"
});
const SvgUk = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14);
};
const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgUk, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/uk.826c4ee1.svg";
export { ForwardRef as ReactComponent };